// Rough check to match a salesforce ID. Can only be 15 (legacy) or 18 characters long
export const SALESFORCE_ID_PATTERN = /^[A-z0-9]{15}([A-z0-9]{3})?$/;

export const MAP_LANGUAGE_TO_SALESFORCE_LANGUAGE_PARAM: Record<string, string> = {
	de: 'de',
	it: 'it',
	fr: 'fr',
	en: 'en_GB'
};
